import { render, staticRenderFns } from "./summary.component.vue?vue&type=template&id=d2877b82&scoped=true"
import script from "./summary.component.vue?vue&type=script&lang=js"
export * from "./summary.component.vue?vue&type=script&lang=js"
import style0 from "./summary.component.vue?vue&type=style&index=0&id=d2877b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2877b82",
  null
  
)

export default component.exports